import React from 'react';
import { CssBaseline, Box, Drawer, AppBar } from '@mui/material';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from '../layout/header';
import LeftNav from '../layout/left_nav';
import Footer from '../layout/footer';
import { useAuth } from '../auth/auth_context';
import ProtectedRoute from '../auth/protected_route';
import { Main, AppBarOffset } from './router_styles';
import { protectedRoutes as getProtectedRoutes, publicRoutes } from './router_config';

function AuthenticatedRouter({ isOpen, toggleNav, isAtBottom, mode, toggleMode, drawerSize }) {
  const { token, isAuthReady } = useAuth();
  const location = useLocation();
  const publicPaths = publicRoutes.map(route => route.path);
  const isPublicRoute = publicPaths.includes(location.pathname);

  if (!isPublicRoute && !isAuthReady) {
    return <div>Loading...</div>;
  }

  // Calculate drawer width
  const drawerWidth = isOpen ? drawerSize.width : drawerSize.widthClosed;

  // Create protected routes using the dynamic props
  const protectedRoutes = getProtectedRoutes(mode, toggleMode);

  // Helper to clone element with extraProps if they are defined.
  const applyExtraProps = (route) => {
    if (route.extraProps) {
      return React.cloneElement(route.element, route.extraProps);
    }
    return route.element;
  };

  return (
    <>
      <CssBaseline />
      {!isPublicRoute && (
        <AppBar position="fixed">
          <Header />
        </AppBar>
      )}
      <Box sx={{ display: 'flex', minHeight: '100vh', overflow: 'hidden' }}>
        {!isPublicRoute && token && (
          <Drawer
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
                marginTop: '64px',
                position: 'fixed',
                height: 'calc(100% - 64px)',
              },
            }}
            variant="permanent"
            anchor="left"
          >
            <LeftNav isOpen={isOpen} toggleNav={toggleNav} sizingNav={drawerSize} />
          </Drawer>
        )}
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          {!isPublicRoute && <AppBarOffset />}
          <Main>
            <Routes>
              {protectedRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={<ProtectedRoute>{applyExtraProps(route)}</ProtectedRoute>}
                />
              ))}
              {publicRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
            </Routes>
          </Main>
          {!isPublicRoute && (
            <Box
              sx={{
                height: '50px',
                transition: 'opacity 0.3s',
                opacity: isAtBottom ? 1 : 0,
                pointerEvents: isAtBottom ? 'auto' : 'none',
              }}
            >
              <Footer sx={{ p: 1, height: '50px' }} />
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}

export default AuthenticatedRouter;